@if (totalCount() > 0) {
    <div class="anc-pagination" role="navigation" aria-label="Table pagination">
        <div class="anc-pg-controls">
            <div class="anc-pg-size">
                <span class="anc-pg-label" translate>Items per page</span>
                <ng-select
                    [ngModel]="pageSize()"
                    (ngModelChange)="onSizeChange($event)"
                    [searchable]="false"
                    [clearable]="false"
                    [disabled]="disabled()"
                    [notFoundText]="'No items found' | translate"
                    appendTo="body"
                    class="anc-page-size-select"
                    panelClass="anc-page-size-panel"
                    [ariaLabel]="'Items per page' | translate"
                >
                    @for (s of pageSizeOptions(); track s) {
                        <ng-option [value]="s">{{ s }}</ng-option>
                    }
                </ng-select>
            </div>

            <div class="anc-pg-goto">
                <label class="anc-pg-label" [attr.for]="gotoInputId" translate>Go to page no.</label>
                <div class="anc-pg-goto-field">
                    <input
                        #gotoInput
                        [id]="gotoInputId"
                        class="anc-pg-goto-input"
                        type="text"
                        inputmode="numeric"
                        [disabled]="disabled()"
                        [ngModel]="gotoPageValue"
                        (ngModelChange)="gotoInput.value = gotoPageValue = sanitizeGotoPage($event)"
                        (keydown.enter)="submitGotoPage()"
                        [attr.aria-label]="'Go to page no.' | translate"
                    />
                    <button
                        type="button"
                        class="anc-pg-goto-btn"
                        (click)="submitGotoPage()"
                        [disabled]="disabled()"
                        [attr.aria-label]="'Go to page' | translate"
                    >
                        <span class="icon icon-arrow-right" aria-hidden="true"></span>
                    </button>
                </div>
            </div>

            <div class="anc-pg-nav">
                <div class="anc-pg-nav-group">
                    <button
                        type="button"
                        class="anc-pg-icon-btn"
                        (click)="goToFirstPage()"
                        [disabled]="disabled() || currentPageNumber() === 1"
                        [attr.aria-label]="'First page' | translate"
                    >
                        <span class="icon icon-chevrons-left" aria-hidden="true"></span>
                    </button>
                    <button
                        type="button"
                        class="anc-pg-icon-btn"
                        (click)="goToPreviousPage()"
                        [disabled]="disabled() || currentPageNumber() === 1"
                        [attr.aria-label]="'Previous page' | translate"
                    >
                        <span class="icon icon-chevron-left" aria-hidden="true"></span>
                    </button>
                </div>

                <span class="anc-pg-info" aria-live="polite">
                    {{ startRecord() }}-{{ endRecord() }}&nbsp;{{ 'of' | translate }}&nbsp;{{ totalCount() }}
                </span>

                <div class="anc-pg-nav-group">
                    <button
                        type="button"
                        class="anc-pg-icon-btn"
                        (click)="goToNextPage()"
                        [disabled]="disabled() || currentPageNumber() === totalPages()"
                        [attr.aria-label]="'Next page' | translate"
                    >
                        <span class="icon icon-chevron-right" aria-hidden="true"></span>
                    </button>
                    <button
                        type="button"
                        class="anc-pg-icon-btn"
                        (click)="goToLastPage()"
                        [disabled]="disabled() || currentPageNumber() === totalPages()"
                        [attr.aria-label]="'Last page' | translate"
                    >
                        <span class="icon icon-chevrons-right" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
}
